/**
* This enumeration contains the Action Type string constants for coupon list
*/
enum ActionType {
    SET_EVENT_COUPON_LIST = 'CouponListActions.SET_EVENT_COUPON_LIST',
}

export default ActionType;
